import React from 'react';
import { SessionStatus } from '@tools/sessionUtils/SessionStatus';
import { injectTestId } from '@cvent/nucleus-test-automation';
import Tag from '@cvent/carina/components/Tag';
import { useTranslate } from 'nucleus-text';
import useSessionStatus from '@tools/sessionUtils/useSessionStatus';
import { CSSObject } from '@emotion/react';
import useBreakpoints from '@hooks/useBreakpoints';
import { chooseWebinarEndedText } from '@components/landing/landingUtils';

interface InfoPageSessionStatusProps {
  now: Date;
  sessionStart: Date | string;
  sessionEnd: Date | string;
  eventEnd: string;
  testID?: string;
}

const useStyles = (): Record<string, CSSObject> => {
  const { mediaIsMobile } = useBreakpoints();

  return {
    landingDescriptionTagContainer: {
      marginBottom: 16,
      [mediaIsMobile]: {
        marginBottom: 8
      }
    },
    endedText: {
      marginLeft: 16
    }
  };
};

function InfoPageSessionStatus({
  now,
  sessionStart,
  sessionEnd,
  eventEnd,
  testID = 'landing-page-main-body'
}: InfoPageSessionStatusProps): JSX.Element {
  const { translate } = useTranslate();
  const sessionStatus = useSessionStatus({ start: sessionStart, end: sessionEnd });
  let tagTestId: string;
  let localizationKey: string;

  const webinarEndedText =
    now >= new Date(eventEnd) &&
    chooseWebinarEndedText({
      now,
      endTime: eventEnd
    });

  const { landingDescriptionTagContainer, endedText } = useStyles();

  if (
    sessionStatus === SessionStatus.MORE_THAN_FIVE_MIN_BEFORE ||
    sessionStatus === SessionStatus.LESS_THAN_FIVE_MIN_BEFORE
  ) {
    tagTestId = `${testID}-upcoming-tag`;
    localizationKey = 'LandingPage-Tag-StartingSoon';
  } else if (sessionStatus === SessionStatus.AFTER) {
    tagTestId = `${testID}-ended-tag`;
    localizationKey = 'LandingPage-Tag-WebinarEnded';
  }

  if (tagTestId !== undefined && localizationKey !== undefined) {
    return (
      <div css={landingDescriptionTagContainer} {...injectTestId(tagTestId)}>
        <Tag text={translate(localizationKey)} />
        {webinarEndedText ? <span css={endedText}>{translate(...webinarEndedText)}</span> : null}
      </div>
    );
  }
  return null;
}

export default InfoPageSessionStatus;
